import { useMantineTheme } from '@mantine/core';
import { EditableEmailProperty } from '../Atoms/EditableProperties/EditableEmailProperty';
import { EditableCheckbox } from '../Atoms/inputs/EditableCheckbox';
import { TransButtonDefaultWithSpinner } from '../Atoms/Buttons';
import PdfPreview from './Document/PdfPreview';

const CheckDocumentPlaceholderWrapper = ({
  eventId,
  attachment,
  addAttachment,
  changeMessage,
  email,
  reload,
  index,
}) => {
  const { colorScheme, colors } = useMantineTheme();

  return (
    <div
      style={{
        display: 'flex',
        padding: '20px 0px',
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: index % 2 ? (colorScheme === 'dark' ? colors.dark[8] : colors.gray[0]) : 'unset',
      }}
    >
      <div style={{ flex: 1, marginLeft: 10, alignSelf: 'center' }}>
        <EditableEmailProperty
          patchField="selected"
          style={{ marginBottom: 0 }}
          preChange={(p) => addAttachment(attachment)}
          changeHandler={changeMessage}
          email={email}
          placeholder={attachment.fileName}
          editOnly
          editFormatter={EditableCheckbox}
        />
      </div>
      <PdfPreview eventId={eventId} file={attachment} button={TransButtonDefaultWithSpinner} />
    </div>
  );
};

export default CheckDocumentPlaceholderWrapper;
